<template>
  <div
    class="container p5-container w-100 h-100 px-0 mx-0"
    style="max-width: 98%"
  >
    <b-row class="h-100"
      ><b-col lg="5" class="p-3">
        <b-card
          class="card-transparent-background card-birth-chart-data-astrology"
        >
          <b-row
            ><b-col>
              <b-card-title>{{ name }}</b-card-title>
              <b-card-text>
                {{ date }}
              </b-card-text>
              <b-card-text> Time: {{ time }} </b-card-text>
              <b-card-text>
                {{ location }}
              </b-card-text></b-col
            >
            <b-col
              ><b-card-text>Natal Chart</b-card-text
              ><b-card-text>Method: Web Style / Placidus </b-card-text
              ><b-card-text> Sun sign: Sagittarius </b-card-text
              ><b-card-text> Ascendant: Libra</b-card-text></b-col
            ></b-row
          >
        </b-card>

        <b-row v-if="!drawPlanetsTable">
          <b-col>
            <b-button
              variant="astrology-primary"
              class="btn-bumblebee btn-astrology float-right"
              @click="drawPlanetsTable = !drawPlanetsTable"
              >Return to table</b-button
            >
          </b-col>
        </b-row>
        <b-card
          class="card-astrology card-dark-transparent-background-astrology py-0"
        >
          <b-table
            v-if="drawPlanetsTable"
            class="birth-chart-table-astrology"
            :borderless="true"
            :small="true"
            :items="planets_houses_anlges_transits_table"
          >
            <template #cell(icon)="row">
              <img
                class="table-img"
                :src="
                  require('@/assets/images/astrology/planets/' +
                    row.item.icon +
                    '.png')
                "
              /> </template
          ></b-table>

          <div v-else>
            <b-card-text class="card-text-birth-chart-data">{{
              clicked_item_title
            }}</b-card-text>
            <div class="accordion birth-chart-data-accordion" role="tablist">
              <b-card
                no-body
                class="mb-1"
                v-for="(item, index) in clicked_item_items"
                :key="item.title"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <p
                    v-b-toggle="'accordion-' + (index + 1)"
                    class="birth-chart-data-title-collapse"
                  >
                    {{ item.title }}
                  </p>
                </b-card-header>
                <b-collapse
                  :id="'accordion-' + (index + 1)"
                  :accordion="'accordion-' + (index + 1)"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text> {{ item.description }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col lg="7" id="p5Container" class="h-100 p-0"
        ><vue-p5
          class="h-100 overflow-auto text-center"
          ref="vueP5BirthChart"
          @preload="preload"
          @setup="setup"
          @draw="draw"
          @redraw="redraw"
          @mouseclicked="mouseclicked"
          :additional-events="['windowresized']"
          @windowresized="windowresized"
          ><div id="p5_loading" class="loadingclass">
            this could be some sweet graphics loading lots of bits.
          </div>
        </vue-p5></b-col
      >
    </b-row>
  </div>
</template>


<script>
import $ from "jquery";
import VueP5 from "vue-p5";

export default {
  name: "P5Index",
  components: { VueP5 },
  props: ["is_birth_chart", "name", "gender", "date", "time", "location"],
  data() {
    return {
      message: "hello p5 from vue",
      canvasSize: null,
      sketch: null,

      aries_shift: 0,
      zodiac_angle: 0,

      zodiac: [],
      planets: [],
      major_houses: [],
      major_houses_label: [],

      planets_houses: [],

      loaded_zodiac: [],
      loaded_planets: [],
      loaded_transit_planets: [],

      zodiac_deg: [],
      houses: [],
      houses_deg: [],
      planets_positions: [],
      planets_deg: [],
      painted_planets_positions: [],
      painted_aspects: [],

      transits_planets_positions: [],
      transits_planets_deg: [],

      planets_houses_anlges_transits_table: [],

      selectedAspects: [],
      clickedAspects: [],

      labelSize: 0,
      rlabel: 0,

      drawAllAspects: true,
      resetButton: null,
      clicked_planet_object: null,
      drawPlanetsTable: true,

      zodiac_diameter: 0,
      house_diameter: 0,
      aspects_circle_diameter: 0,
      circle_size: 0,
      planet_img_size: 0,
      zodiac_img_size: 0,

      clicked_item_title:
        "You have clicked on zodiac Leo. There are 3 planets in this zodiac",
      clicked_item_items: [
        {
          title: "Sun in Leo",
          description:
            'You are spirited and strong willed and like to be the center of attention. Other people like you because you are basically warm and affectionate. You work very hard to get your way with others. You should be careful of carrying this trait too far, however, because it may turn away people who would otherwise be your friends. You are proud and consider yourself important. The positive side of this is that you are reluctant to compromise yourself. When you are older, you will want to be a person of some importance and, if possible, a leader. Even while you are young you will play this role whenever possible, which should work out very well, because you also want to be worthy of being a leader. Interpretation by Robert Hand from "Youth Portrait", which is also an interesting read for grown-ups.',
        },
        {
          title: "Mercury in Leo",
          description:
            'You are very sure that your ideas are right, and you like to make others think the way you do. You can think about new ideas and make them part of your own thinking, as long as no one is pressuring you to do so. You are quite stubborn, and your pride is involved in everything you think or believe. If someone challenges your beliefs, you feel they are challenging you. But at the same time, your pride in your opinions makes you want to get at the truth.Whenever you have to solve a problem, you put a great deal of energy into it, and the more important the problem, the more energy you invest. However, you may ignore problems that don\'t seem important enough, when actually they are quite important.Interpretation by Robert Hand from "Youth Portrait", which is also an interesting read for grown-ups.',
        },
      ],
    };
  },
  updated() {},
  mounted() {
    console.log(this.planets_houses);
  },
  methods: {
    clickReturnTable() {
      console.log(this.drawPlanetsTable);
      this.drawPlanetsTable = true;
      console.log(this.drawPlanetsTable);
    },
    loadChartData() {
      this.aries_shift = 360 - 299.9067;
      this.zodiac_angle = 30;

      this.zodiac = [
        "aries",
        "taurus",
        "gemini",
        "cancer",
        "leo",
        "virgo",
        "libra",
        "scorpio",
        "sagittarius",
        "capricorn",
        "aquarius",
        "pisces",
      ];
      this.planets = [
        "sun",
        "moon",
        "mercury",
        "venus",
        "mars",
        "jupiter",
        "saturn",
        "uranus",
        "neptune",
        "pluto",
        "mean_node",
        "true_node",
        "chiron",
      ];
      this.major_houses = [];
      this.major_houses_label = ["AC", "IC", "DC", "MC"];

      this.planets_houses = [
        ["Sun", "269°26'36.3153"],
        ["Moon", "172°50' 5.2501"],
        ["Mercury", "260°21'28.2500"],
        ["Venus", "303°19'21.0120"],
        ["Mars", "302°21'32.8359"],
        ["Jupiter", "320° 5'54.5585"],
        ["Saturn", "13°33'20.6139"],
        ["Uranus", "306°33'56.4332"],
        ["Neptune", "298°33'53.7285"],
        ["Pluto", "246°22'54.7661"],
        ["mean Node", "164°17'34.6873"],
        ["true Node", "163°37' 3.3516"],
        ["mean Apogee", "180°42'57.3649"],
        ["house  1", "299°52'24.3790"],
        ["house  2", "340°15'51.3093"],
        ["house  3", "17°43' 4.3379"],
        ["house  4", "47°23'15.4490"],
        ["house  5", "71°40'31.7232"],
        ["house  6", "94°24'18.0235"],
        ["house  7", "119°52'24.3790"],
        ["house  8", "160°15'51.3093"],
        ["house  9", "197°43' 4.3379"],
        ["house 10", "227°23'15.4490"],
        ["house 11", "251°40'31.7232"],
        ["house 12", "274°24'18.0235"],
        ["Ascendant", "299°52'24.3790"],
        ["MC", "227°23'15.4490"],
        ["ARMC", "224°55'25.2744"],
        ["Vertex", "151°29'41.8631"],
        ["equat. Asc.", "312°27'37.1303"],
        ["co-Asc. W.Koch", "321°28' 2.7650"],
        ["co-Asc Munkasey", "269°21'15.6431"],
        ["Polar Asc.", "141°28' 2.7650"],
      ];

      this.loaded_zodiac = [];
      this.loaded_planets = [];
      this.loaded_transit_planets = [];

      this.zodiac_deg = [];
      this.houses = [];
      this.houses_deg = [];
      this.planets_positions = [];
      this.planets_deg = [];
      this.painted_planets_positions = [];
      this.painted_aspects = [];

      this.transits_planets_positions = [];
      this.transits_planets_deg=[];

      this.selectedAspects = [];
      this.clickedAspects = [];

      this.labelSize = 18;
      this.rlabel = 1.1;

      this.drawAllAspects = true;
    },
    preload(sketch) {
      console.log("in preload");
      this.loadChartData();
      // load images
      for (let i = 0; i < this.zodiac.length; i++) {
        //require('@/assets/tankman.png')
        let img = sketch.loadImage(
          require("@/assets/images/astrology/zodiac/" + this.zodiac[i] + ".png")
        );
        // let img = sketch.loadImage("zodiac_icons/" + this.zodiac[i] + ".png");
        this.loaded_zodiac.push(img);
      }
      // console.log(this.loaded_zodiac);
      for (let i = 0; i < this.planets.length; i++) {
        let img = sketch.loadImage(
          require("@/assets/images/astrology/planets/" +
            this.planets[i] +
            ".png")
        );
        this.loaded_planets.push(img);

        let imgT = sketch.loadImage(
          require("@/assets/images/astrology/transit_planets/" +
            this.planets[i] +
            ".png")
        );
        this.loaded_transit_planets.push(imgT);
      }

      this.houses = this.planets_houses.slice(13, 25);
      console.log(this.houses);
      this.aries_shift =
        360 -
        this.getDegInDecimal(
          sketch,
          this.getDegMinSec(sketch, this.houses[0][1].replace(" ", ""))
        );

      // load zodiac angles
      for (let i = 0; i < this.zodiac.length; i++) {
        this.zodiac_deg.push(this.aries_shift + i * this.zodiac_angle);
      }
      console.log(this.zodiac_deg);
      //load houses & angles
      this.houses_deg = [];
      for (let i = 0; i < this.houses.length; i++) {
        let deg = this.getDegInDecimal(
          sketch,
          this.getDegMinSec(sketch, this.houses[i][1].replace(" ", ""))
        );

        // console.log(i, houses[i][0], houses[i][1],
        //             getDegMinSec(houses[i][1].replace(' ','')),
        //     getDegInDecimal(getDegMinSec(houses[i][1].replace(' ',''))) ,
        //            aries_shift + ( deg))

        this.houses_deg.push(this.aries_shift + deg);
      }
      // console.log(houses_deg)
      // houses = [0, aries_shift + (360 - house2), aries_shift + (360 - house3), aries_shift + (360 - house4), aries_shift + (360 - house5), aries_shift + (360 - house6), aries_shift + (360 - house7), aries_shift + (360 - house8), aries_shift - (360 - house9), aries_shift + (360 - house10), aries_shift + (360 - house11)]
      //houses_deg

      // load planets
      this.planets_positions = this.planets_houses.slice(0, 12);
      this.transits_planets_positions = this.planets_houses.slice(0, 12);
      this.planets_deg = [];
      this.transits_planets_deg=[];
      this.planets_houses_anlges_transits_table = [];
      for (let i = 0; i < this.planets_positions.length; i++) {
        let deg = this.getDegInDecimal(
          sketch,
          this.getDegMinSec(
            sketch,
            this.planets_positions[i][1].replace(" ", "")
          )
        );
        let deg_transit = this.getDegInDecimal(
          sketch,
          this.getDegMinSec(
            sketch,
            this.transits_planets_positions[i][1].replace(" ", "")
          )
        );

        this.planets_deg.push(this.aries_shift + deg);
        this.transits_planets_deg.push(this.aries_shift + deg_transit)
        // console.log("=======--------------------");
        let [z, a] = this.getAngleAndZodiac(
          sketch,
          180 - (this.aries_shift + deg)
        );
        let [zt, at] = this.getAngleAndZodiac(
          sketch,
          180 - (this.aries_shift + deg_transit)
        );
        this.planets_houses_anlges_transits_table.push({
          icon: this.planets[i],
          planet: this.planets[i].replace("_", " "),
          deg: this.zodiac[z].substr(0, 3) + " " + a,
          // deg_transit: this.zodiac[zt].substr(0, 3) + " " + at,
        });
      }


      console.log(this.planets_positions);
      console.log(this.planets_deg);
    },
    setup(sketch) {
      let width = $("#p5Container").width(),
        height = $("#p5Container").height();
      console.log(width, height);

      this.canvasSize = sketch.min(width, height) - 40;
      if (this.canvasSize < 600) {
        this.canvasSize = 600;
      }
      this.sketch = sketch;

      sketch.createCanvas(this.canvasSize, this.canvasSize);
      // sketch.createCanvas(this.canvasSize, this.canvasSize);

      console.log(sketch.displayWidth, sketch.displayHeight);
      console.log(width, height);
      sketch.angleMode(sketch.DEGREES);
      sketch.cursor(sketch.HAND);
      sketch.noLoop();

      this.zodiac_diameter = this.canvasSize * 0.8;
      this.house_diameter = this.canvasSize * 0.6;
      this.aspects_circle_diameter = this.canvasSize * 0.35;
      this.circle_size = this.canvasSize * 0.1;
      this.planet_img_size = this.canvasSize * 0.025;
      this.zodiac_img_size = this.canvasSize * 0.05;

      this.resetButton = sketch.createButton("Reset");
      this.resetButton.position(0, 0);
      this.resetButton.addClass(
        "btn btn-bumblebee btn-astrology btn-astrology-primary btn-filter d-none"
      );
      this.resetButton.style("display", "none");
      this.resetButton.mousePressed(this.resetAspects);
    },

    windowresized(sketch) {
      let width = $("#p5Container").width(),
        height = $("#p5Container").height();
      console.log(width, height);
      this.canvasSize = sketch.min(width, height) - 40;
      if (this.canvasSize < 600) {
        this.canvasSize = 600;
      }
      sketch.resizeCanvas(this.canvasSize, this.canvasSize);
      // sketch.createCanvas(this.canvasSize, this.canvasSize);

      this.zodiac_diameter = this.canvasSize * 0.8;
      this.house_diameter = this.canvasSize * 0.6;
      this.aspects_circle_diameter = this.canvasSize * 0.35;
      this.circle_size = this.canvasSize * 0.1;
      this.planet_img_size = this.canvasSize * 0.025;
      this.zodiac_img_size = this.canvasSize * 0.05;
    },
    draw(sketch) {
      console.log("draw ", this.is_birth_chart);
      if (this.is_birth_chart) {
        console.log(sketch);
        // sketch.background(200);
        sketch.noStroke();
        this.sketch = sketch;
        this.drawBirthChart(sketch);
      }
    },
    redraw(sketch) {
      console.log("redraw ");
      console.log(sketch);
      // sketch.background(200);
      // sketch.noStroke();
      // this.drawBirthChart(sketch);
      if (this.is_birth_chart) {
        console.log(sketch);
        // sketch.background(200);
        sketch.noStroke();
        this.sketch = sketch;
        this.drawBirthChart(sketch);
      }
    },

    drawBirthChart(sketch) {
      console.log("draw birth chart");
      console.log(sketch);
      // console.log(zodiac_deg)
      // draw zodiac arcs
      this.pieChartTotal(
        sketch,
        this.zodiac_diameter,
        this.zodiac_deg,
        "zodiac"
      );

      // draw zodiac imgs
      this.drawZodiacImgs(sketch, this.zodiac_diameter, this.zodiac_deg);

      // draw angles in zodiac
      this.drawDegreesInZodiac(
        sketch,
        sketch.width / 2,
        sketch.height / 2,
        this.house_diameter / 2,
        5,
        0
        //this.aries_shift
      );
      // return;
      // draw houses
      this.pieChartTotal(sketch, this.house_diameter, this.houses_deg, "house");
      // draw major houses
      this.drawMajorHouses(sketch);

      //draw planets
      this.drawPlanets(
        sketch,
        this.house_diameter / 2,
        this.aspects_circle_diameter / 2
      );

      if (this.drawAllAspects == true) {
        this.drawAspects(sketch, this.planets, this.planets_deg);
        this.resetButton.removeClass("d-block");
        this.resetButton.addClass("d-none");
      } else {
        this.drawAspectsOfPlanet(sketch);
        this.resetButton.removeClass("d-none");
        this.resetButton.addClass("d-block");
      }

      sketch.strokeWeight(2);
      // sketch.stroke("red");
      sketch.stroke("white");
      sketch.fill("#3c3743");
      sketch.circle(sketch.width / 2, sketch.height / 2, this.circle_size);
    },
    pieChartTotal(sketch, diameter, data, type) {
      console.log("in draw pie chart total");
      console.log(diameter, type);
      console.log(data);
      this.major_houses = [];
      for (let i = 0; i < data.length; i++) {
        // console.log(data[i], data[i + 1]);
        let gray = "#3c3743"; //sketch.map(i, 0, data.length, 0, 255);
        if (type == "house") {
          gray = "#48434f";
        }
        sketch.fill(gray);
        // sketch.stroke("red");
        sketch.stroke("white");
        sketch.strokeWeight(1);

        sketch.arc(
          sketch.width / 2,
          sketch.height / 2,
          diameter,
          diameter,
          180 - data[(i + 1) % data.length],
          180 - data[i],
          sketch.PIE
        );

        if (type == "house") {
          if (i % 3 == 0) {
            let a = 180 - data[i];
            // if(i%6 == 0){
            //   a = a*-1
            // }
            this.major_houses.push(a);
            // strokeWeight(4)
          } else {
            // strokeWeight(2)
          }

          // sketch.noStroke();
          // sketch.fill("#877E97");
          sketch.fill("#3c3743");

          sketch.arc(
            sketch.width / 2,
            sketch.height / 2,
            this.aspects_circle_diameter,
            this.aspects_circle_diameter,
            180 - data[(i + 1) % data.length],
            180 - data[i],
            sketch.PIE
          );

          sketch.textSize(this.labelSize);
          sketch.noStroke();
          let wText = sketch.textWidth(String(data[i]));
          let hText = sketch.textAscent() - sketch.textDescent();
          // console.log(wText,hText)
          // fill("#0081F8")
          // console.log(wText);
          // text(data[i],
          //     width/2+sketch.cos(360-lastAngle-(data[i]/2))*diameter/2*(rlabel/2)-wText/2,
          //    height/2+sketch.sin(360-lastAngle-(data[i]/2))*diameter/2*(rlabel/2)+hText/2);

          wText = sketch.textWidth(String(i + 1));
          // textSize(14)
          sketch.textSize(this.planet_img_size / 1.1);
          sketch.fill("yellow");
          // console.log(wText);
          let textAngle =
            ((data[i % 12] % 360) + (data[(i + 1) % 12] % 361)) / 2;

          sketch.textAlign(sketch.CENTER, sketch.CENTER);

          sketch.text(
            i + 1,
            sketch.width / 2 +
              ((sketch.cos(180 - textAngle) * diameter) / 4) *
                (this.rlabel / 2),
            sketch.height / 2 +
              ((sketch.sin(180 - textAngle) * diameter) / 4) * (this.rlabel / 2)
          );
        }
      }
    },
    drawMajorHouses(sketch) {
      for (let i = 0; i < this.major_houses.length; i++) {
        sketch.stroke("orange");
        sketch.strokeWeight(1);
        sketch.line(
          sketch.width / 2,
          sketch.height / 2,
          sketch.width / 2 +
            (this.house_diameter / 2) * sketch.cos(this.major_houses[i]),
          sketch.height / 2 +
            (this.house_diameter / 2) * sketch.sin(this.major_houses[i])
        );

        let startBlackX = sketch.round(
            sketch.width / 2 +
              (this.zodiac_diameter / 2) * sketch.cos(this.major_houses[i]),
            2
          ),
          startBlackY = sketch.round(
            sketch.height / 2 +
              (this.zodiac_diameter / 2) * sketch.sin(this.major_houses[i]),
            2
          ),
          endBlackX = sketch.round(
            sketch.width / 2 +
              (this.zodiac_diameter / 2 + 15) *
                sketch.cos(this.major_houses[i]),
            2
          ),
          endBlackY = sketch.round(
            sketch.height / 2 +
              (this.zodiac_diameter / 2 + 15) *
                sketch.sin(this.major_houses[i]),
            2
          );

        // console.log(this.major_houses[i]);
        sketch.stroke("#fff");
        sketch.strokeWeight(2);
        sketch.line(startBlackX, startBlackY, endBlackX, endBlackY);

        sketch.noStroke();
        //      text(i+1,
        //             width/2+cos(360-lastAngle-(data[i]/2))*diameter/4*(rlabel/2)-wText/2,
        //            height/2+sin(360-lastAngle-(data[i]/2))*diameter/4*(rlabel/2)+hText/2);
        if (this.drawAllAspects == true) {
          // console.log("before draw span")

          let m = this.major_houses_label[i];
          let angle_text = this.getAngleInZodiac(sketch, this.major_houses[i]);
          // let w = sketch.textWidth(m + " " + angle_text);
          let w = sketch.textWidth(angle_text);

          // alert(w)
          //   fill("yellow")
          // rectMode(CENTER);
          // rect( textX, textY, textWidth(m), textSize())
          let textX, textY;
          if (i % 2 == 0) {
            textX = sketch.round(
              sketch.width / 2 +
                (this.zodiac_diameter / 2 + w / 1.25) *
                  sketch.cos(this.major_houses[i]),
              2
            );
            textY = sketch.round(
              sketch.height / 2 +
                (this.zodiac_diameter / 2 + w / 1.25) *
                  sketch.sin(this.major_houses[i]),
              2
            );
          } else {
            textX = sketch.round(
              sketch.width / 2 +
                (this.zodiac_diameter / 2 + 30) *
                  sketch.cos(this.major_houses[i]),
              2
            );
            textY = sketch.round(
              sketch.height / 2 +
                (this.zodiac_diameter / 2 + 30) *
                  sketch.sin(this.major_houses[i]),
              2
            );
          }

          sketch.fill("#fff");
          sketch.textAlign(sketch.CENTER, sketch.CENTER);

          if (i % 2 == 0) {
            sketch.text(m, textX, textY);

            w = sketch.textWidth(angle_text);

            textX = sketch.round(
              sketch.width / 2 +
                (this.zodiac_diameter / 2 + w / 1.25) *
                  sketch.cos(this.major_houses[i] - 3),
              2
            );
            textY = sketch.round(
              sketch.height / 2 +
                (this.zodiac_diameter / 2 + w / 1.25) *
                  sketch.sin(this.major_houses[i] - 3),
              2
            );

            sketch.text(angle_text, textX, textY);
          } else {
            sketch.text(m + " " + angle_text, textX, textY);
          }
        }
      }
    },

    drawZodiacImgs(sketch, diameter, zodiac_deg) {
      console.log("in draw zodiac imgs");
      for (let i = 0; i < this.zodiac_deg.length; i++) {
        // console.log(zodiac_deg[i])
        sketch.imageMode(sketch.CENTER);
        sketch.image(
          this.loaded_zodiac[i],
          sketch.width / 2 +
            ((sketch.cos(180 - this.zodiac_deg[i] - 15) * diameter) / 1.25) *
              (this.rlabel / 2),
          sketch.height / 2 +
            ((sketch.sin(180 - this.zodiac_deg[i] - 15) * diameter) / 1.25) *
              (this.rlabel / 2),
          this.zodiac_img_size,
          this.zodiac_img_size
        );
      }
    },
    drawDegreesInZodiac(sketch, x, y, diameter, step, start) {
      // sketch.strokeWeight(1);
      start = sketch.int(start);

      // strokeCap(SQUARE);
      //Iterate 360 degrees of lines, +10deg per turn
      // console.log("===================")
      let count = 0;
      for (let a = start; a < 360 + start; a += 1) {
        // console.log(a, step)
        // sketch.stroke("red"); //hue based on a
        //radius is 100, angle is a degrees
        // console.log(x + rad * cos(a),
        //  y + rad * sin(a))
        // console.log("count ",count, count%30)
        let startX = sketch.round(
            sketch.width / 2 + diameter * sketch.cos(a),
            2
          ),
          startY = sketch.round(
            sketch.height / 2 + diameter * sketch.sin(a),
            2
          ),
          endX = sketch.round(
            sketch.width / 2 + (diameter + 12) * sketch.cos(a),
            2
          ),
          endY = sketch.round(
            sketch.height / 2 + (diameter + 12) * sketch.sin(a),
            2
          );

        if (count % 30 == 0) {
          // stroke('#0081F8')
          // line(x, y, x + rad*2 * cos(a), y + rad*2* sin(a));
        } else if ((count % 30) % 5 == 0) {
          sketch.stroke("#0081F8");
          sketch.line(sketch.width / 2, sketch.height / 2, endX, endY);
        } else {
          sketch.stroke("#4EC33D");
          // endX = sketch.round(
          //   sketch.width / 2 + (diameter + 7) * sketch.cos(a),
          //   2
          // );
          // endY = sketch.round(
          //   sketch.height / 2 + (diameter + 7) * sketch.sin(a),
          //   2
          // );
          endX = sketch.width / 2 + (diameter + 7) * sketch.cos(a);
          endY = sketch.height / 2 + (diameter + 7) * sketch.sin(a);

          sketch.line(sketch.width / 2, sketch.height / 2, endX, endY);
        }
        //     if(count%6==1){

        //     }else if(count%6 == 3 || count%6 == 5){
        //       stroke("#0081F8")
        //       line(x, y, x + rad * cos(a), y + rad * sin(a));
        //     }else{
        //       stroke("#4EC33D")
        //       line(x, y, x + rad/1.05 * cos(a), y + rad/1.05 * sin(a));
        //     }
        count++;
      }
    },
    drawPlanets(sketch, diameter, aspects_circle_diameter) {
      console.log("in draw planets");
      // console.log(width, height, canvasSize,diameter)
      this.painted_planets_positions = [];
      this.planets_positions_xy = [];
      for (let i = 0; i < this.planets_deg.length; i++) {
        // console.log(this.planets_deg[i], this.planets_positions[i]);
        let total_angle = 180 - this.planets_deg[i];
        // console.log("----", total_angle);
        let startX = sketch.round(
            sketch.width / 2 + diameter * sketch.cos(total_angle),
            2
          ),
          startY = sketch.round(
            sketch.height / 2 + diameter * sketch.sin(total_angle),
            2
          ),
          endX = sketch.round(
            sketch.width / 2 + (diameter - 10) * sketch.cos(total_angle),
            2
          ),
          endY = sketch.round(
            sketch.height / 2 + (diameter - 10) * sketch.sin(total_angle),
            2
          ),
          imgX = sketch.round(
            sketch.width / 2 + (diameter - 20) * sketch.cos(total_angle),
            2
          ),
          imgY = sketch.round(
            sketch.height / 2 + (diameter - 20) * sketch.sin(total_angle),
            2
          );
        // sketch.stroke("purple");
        sketch.stroke("#A16AE8");
        sketch.line(startX, startY, endX, endY);

        startX = sketch.round(
          sketch.width / 2 + aspects_circle_diameter * sketch.cos(total_angle),
          2
        );
        startY = sketch.round(
          sketch.height / 2 + aspects_circle_diameter * sketch.sin(total_angle),
          2
        );
        endX = sketch.round(
          sketch.width / 2 +
            (aspects_circle_diameter - 7) * sketch.cos(total_angle),
          2
        );
        endY = sketch.round(
          sketch.height / 2 +
            (aspects_circle_diameter - 7) * sketch.sin(total_angle),
          2
        );

        sketch.stroke("#4EC33D");
        sketch.line(startX, startY, endX, endY);

        this.painted_planets_positions.push({
          planet: this.planets[i],
          x: imgX,
          y: imgY,
          width: this.planet_img_size,
          height: this.planet_img_size,
          angle: total_angle,
          real_angle: total_angle,
          zodiac_index: this.getZodiacOrPlanetOfAngle(
            sketch,
            total_angle,
            this.zodiac_deg,
            "zodiac"
          ),
          house_index: this.getZodiacOrPlanetOfAngle(
            sketch,
            total_angle,
            this.houses_deg,
            "house"
          ),
        });

        this.planets_positions_xy.push([startX, startY]);
      }
      console.log(this.painted_planets_positions);
      this.checkPlanetsOverlapping(sketch, diameter);
      // this.drawAspects(sketch, this.planets, this.planets_deg);
    },
    checkPlanetsOverlapping(sketch, diameter) {
      console.log("in check planet overlapping");
      this.painted_planets_positions.sort((a, b) =>
        a.angle < b.angle ? 1 : -1
      );
      // console.log(this.painted_planets_positions);

      for (let i = 0; i < this.painted_planets_positions.length - 1; i++) {
        // console.log("iiiiiiiiiiiiiiiiiiiiiiiiiii")
        let planet1 = this.painted_planets_positions[i];
        let rect1 = {
          x: planet1.x - planet1.width / 2,
          y: planet1.y - planet1.height / 2,
          width: planet1.width,
          height: planet1.height,
        };
        // console.log(planet1)
        // console.log(rect1)
        let j = i + 1;
        // for(let j=i+1; j<painted_planets_positions.length; j++){
        let planet2 = this.painted_planets_positions[j];
        let rect2 = {
          x: planet2.x - planet2.width / 2,
          y: planet2.y - planet2.height / 2,
          width: planet2.width,
          height: planet2.height,
        };
        // console.log("    ",planet2)
        // console.log("    ",rect2)
        let intersect = null;

        do {
          intersect = this.intersection(rect1, rect2);
          // console.log("    ===>",planet1.planet, planet2.planet,
          //       intersect  )

          if (intersect != false) {
            //    stroke("#4EC33D")
            // strokeWeight(1)
            // rectMode(CORNER);
            // rect(intersect.x, intersect.y,
            //      intersect.width, intersect.height)
            // console.log( painted_planets_positions[j].angle)
            this.painted_planets_positions[j].angle -= 1;
            // console.log( painted_planets_positions[j].angle)

            this.painted_planets_positions[j].x = sketch.round(
              sketch.width / 2 +
                (diameter - 20) *
                  sketch.cos(this.painted_planets_positions[j].angle),
              2
            );
            this.painted_planets_positions[j].y = sketch.round(
              sketch.height / 2 +
                (diameter - 20) *
                  sketch.sin(this.painted_planets_positions[j].angle),
              2
            );

            planet2 = this.painted_planets_positions[j];
            rect2 = {
              x: planet2.x - planet2.width / 2,
              y: planet2.y - planet2.height / 2,
              width: planet2.width,
              height: planet2.height,
            };
          }
        } while (intersect != false);

        //       if(intersect != false){
        //         // stroke("red")
        //         // strokeWeight(1)
        //         // rectMode(CORNER);
        //         // rect(intersect.x, intersect.y,
        //         //      intersect.width, intersect.height)
        //        // console.log( painted_planets_positions[j].angle)
        //         painted_planets_positions[j].angle += 1
        //        // console.log( painted_planets_positions[j].angle)

        //         painted_planets_positions[j].x = round( width/2 + 180 * cos(painted_planets_positions[j].angle),2)
        //         painted_planets_positions[j].y =round( height/2 + 180 * sin(painted_planets_positions[j].angle),2)

        //         planet2 = painted_planets_positions[j]
        //         rect2 = {'x': planet2.x-planet2.width/2,
        //                    'y': planet2.y-planet2.height/2,
        //                    width: planet2.width, height: planet2.height}

        //       //   intersect =  intersection(rect1, rect2)
        //       // console.log("    --->",planet1.planet, planet2.planet,
        //       //         intersect  )
        //       //   if(intersect!=false){
        //       //     stroke("#4EC33D")
        //       //   strokeWeight(1)
        //       //   rectMode(CORNER);
        //       //   rect(intersect.x, intersect.y,
        //       //        intersect.width, intersect.height)
        //        // }
        //       }
        //}
      }

      // after fix overlap
      for (let i = 0; i < this.painted_planets_positions.length; i++) {
        let planet = this.painted_planets_positions[i];
        //  rectMode(CENTER);
        // rect(planet.x, planet.y,planet.width, planet.height)

        sketch.imageMode(sketch.CENTER);

        let pIndex = this.planets.indexOf(
          this.painted_planets_positions[i].planet
        );
        sketch.image(
          this.loaded_planets[pIndex],
          planet.x,
          planet.y,
          this.planet_img_size,
          this.planet_img_size
        );

        // if(drawAllAspects == true){
        let textX = sketch.round(
            sketch.width / 2 +
              (this.house_diameter / 2 - 48) *
                sketch.cos(this.painted_planets_positions[i].angle),
            2
          ),
          textY = sketch.round(
            sketch.height / 2 +
              (this.house_diameter / 2 - 40) *
                sketch.sin(this.painted_planets_positions[i].angle),
            2
          );
        // console.log("pppppp", planets_deg[pIndex],
        //             planets[pIndex]+" "+getAngleInZodiac(180- planets_deg[pIndex]))
        // let span = createDiv(getAngleInZodiac(180- planets_deg[pIndex]));
        // let span = createSpan('10 25')
        // span.position(textX,textY);
        // span.style("color","#4EC33D")
        // span.style("font-size","12px")
        // span.center()

        sketch.noStroke();
        sketch.fill("#4EC33D");
        sketch.textAlign(sketch.CENTER, sketch.CENTER);
        sketch.textSize(this.planet_img_size - 7);
        sketch.text(
          this.getAngleInZodiac(sketch, 180 - this.planets_deg[pIndex]),
          textX,
          textY
        );
        // }
      }
    },

    drawAspects(sketch, planets, planets_angles) {
      console.log("draw aspects");
      console.log(planets);
      console.log(planets_angles);
      this.painted_aspects = [];

      // console.log("============")
      sketch.strokeWeight(2);
      for (let i = 0; i < planets.length - 3; i++) {
        // let ss = 0
        // for(let i=ss; i<ss+1; i++){
        // console.log("==>",planets[i], planets_angles[i] )
        // if(planets_angles[i] > 360){
        //  planets_angles[i]-= 360
        // }

        for (let j = i + 1; j < planets.length - 3; j++) {
          if (planets[j] != "mean_node" && planets[j] != "true_node") {
            // if(planets_angles[j] > 360){
            // planets_angles[j]-= 360
            // }
            let diff = planets_angles[i] - planets_angles[j];

            let extra_orb = 2;
            if (planets[i] == "sun" || planets[i] == "moon") {
              extra_orb = 2;
            }
            //   console.log("      conj ",-(8+extra_orb), (8+extra_orb))
            // console.log("      sextile ",(56-extra_orb), (64+extra_orb))
            // console.log("      square ",(82-extra_orb), (98+extra_orb))
            // console.log("      trines ",(112-extra_orb), (128+extra_orb))
            // console.log("      opposition ",(172-extra_orb), (188+extra_orb))
            // console.log("      inconjunct ",(148-extra_orb), (152+extra_orb))

            let aspect_type = "";
            // console.log("   ",planets[j], planets_angles[j], diff, aspect_type )
            if (diff < 0) {
              diff *= -1;
            }
            if (diff > 180) {
              diff = 360 - diff;
            }
            // diff = round(diff)
            let draw_aspect = false;

            if (diff >= -(8 + extra_orb) && diff <= 8 + extra_orb) {
              aspect_type = "conjunction";
              // console.log("--->", planets_positions_xy[i], planets_positions_xy[j])
              sketch.stroke("#90f542");
              draw_aspect = true;
            } else if (diff >= 56 - extra_orb && diff <= 64 + extra_orb) {
              aspect_type = "sextile";
              sketch.stroke("#f75f28");
              draw_aspect = true;
            } else if (diff >= 82 - extra_orb && diff <= 98 + extra_orb) {
              aspect_type = "square";
              sketch.stroke("#28e6f7");
              draw_aspect = true;
            } else if (diff >= 112 - extra_orb && diff <= 128 + extra_orb) {
              aspect_type = "trines";
              sketch.stroke("#f728a1");
              draw_aspect = true;
            } else if (diff >= 172 - extra_orb && diff <= 188 + extra_orb) {
              sketch.stroke("#2877f7");
              aspect_type = "opposition";
              draw_aspect = true;
            }
            if (draw_aspect) {
              sketch.line(
                this.planets_positions_xy[i][0],
                this.planets_positions_xy[i][1],
                this.planets_positions_xy[j][0],
                this.planets_positions_xy[j][1]
              );

              this.painted_aspects.push({
                from_planet: planets[i],
                to_planet: planets[j],
                from_x: this.planets_positions_xy[i][0],
                from_y: this.planets_positions_xy[i][1],
                to_x: this.planets_positions_xy[j][0],
                to_y: this.planets_positions_xy[j][1],
                aspect_type: aspect_type,
              });
            }
            // else if(diff >= (148-extra_orb) && diff<= (152+extra_orb)){
            //   stroke("#7ED41A")
            //   line(planets_positions_xy[i][0],planets_positions_xy[i][1], planets_positions_xy[j][0], planets_positions_xy[j][1])
            //   aspect_type = "inconjunct"
            // }

            // console.log("   ",planets[j], planets_angles[j], diff, aspect_type )
          }
        }
      }
      console.log("======= painted aspects");
      console.log(this.painted_aspects);
    },
    drawAspectsOfPlanet(sketch) {
      /*painted_aspects.push({'from_planet': planets[i],
                             'to_planet': planets[j],
                             'from_x':planets_positions_xy[i][0],
                             'from_y': planets_positions_xy[i][1],
                             'to_x': planets_positions_xy[j][0],
                             'to_y': planets_positions_xy[j][1],
                             'aspect_type': aspect_type})*/
      console.log("in draw aspects of planet");
      for (let i = 0; i < this.selectedAspects.length; i++) {
        let aspect = this.selectedAspects[i];
        sketch.strokeWeight(2);
        sketch.stroke("#41ee41");
        sketch.line(aspect.from_x, aspect.from_y, aspect.to_x, aspect.to_y);
      }
    },

    /////////// click action
    mouseclicked(sketch) {
      // console.log(
      //   "click mouse ",
      //   sketch.mouseX,
      //   sketch.mouseY,
      //   sketch.width / 2,
      //   sketch.height / 2
      // );
      // check if click in zodiac arc
      //start_draw_zodiac , 530, 400
      let mouseDist = sketch.dist(
        sketch.width / 2,
        sketch.height / 2,
        sketch.mouseX,
        sketch.mouseY
      );
      let mouseAngle = sketch.atan2(
        sketch.mouseY - sketch.height / 2,
        sketch.mouseX - sketch.width / 2
      );

      // console.log(mouseDist, mouseAngle);

      // if (mouseDist > this.zodiac_diameter / 2) {
      //   console.log("click on > ", this.zodiac_diameter / 2);
      //   // let clicked_transit_planet =
      //   //     getClickedTransitPlanet(mouseX, mouseY)
      //   // console.log("clicked transit planet ",clicked_transit_planet)

      //   // this.drawPlanetsTable = true;
      // } else 
      if (
        mouseDist >= this.house_diameter / 2 &&
        mouseDist <= this.zodiac_diameter / 2
      ) {
      this.drawPlanetsTable = false;
        console.log("click on zodiac");
        let [zodiac_index, zodiac] = this.getClickedZodiac(
          sketch,
          mouseDist,
          mouseAngle
        );
        console.log(zodiac_index, zodiac);
        console.log(this.painted_planets_positions);
        if (zodiac != null) {
          this.displayClickedZodiacData(zodiac, zodiac_index);
        }
      } else if (
        mouseDist >= this.aspects_circle_diameter / 2 &&
        mouseDist <= this.house_diameter / 2
      ) {
      this.drawPlanetsTable = false;
        console.log("click on house");
        let house = this.getClickedHouse(sketch, mouseDist, mouseAngle);
        console.log("clicked on house no", house);

        this.clicked_planet_object = this.getClickedPlanet(
          sketch,
          sketch.mouseX,
          sketch.mouseY
        );
        if (this.clicked_planet_object != null) {
          console.log("clicked on planet ", this.clicked_planet_object);

          this.getAspectsOfClickedPlanets(
            sketch,
            this.clicked_planet_object.planet
          );
          // this.redraw();
          this.drawBirthChart(sketch);

          this.displayClickedPlanetData(this.clicked_planet_object);
        } else {
          this.displayClickedHouseData(house);
        }
      } else if (mouseDist <= this.aspects_circle_diameter / 2) {
      this.drawPlanetsTable = false;
        console.log("clicked on aspects circle");
        this.getClickAspect(sketch, sketch.mouseX, sketch.mouseY);
        this.displayClickedAspects();
      }
    },
    getClickedZodiac(sketch, mouseDist, mouseAngle) {
      console.log("get clicked zoidac ", mouseAngle);
      // console.log(this.zodiac_deg);

      // if(mouseAngle > 180-aries_shift && mouseAngle <=180){
      //    mouseAngle = mouseAngle -360
      // }
      mouseAngle = 180 - mouseAngle;
      // let lastAngle = 180+start_zodiac_angle;
      for (let i = 0; i < this.zodiac_deg.length; i++) {
        //     console.log("== ", mouseAngle,180-mouseAngle, mouseAngle-180, 180-start_zodiac_angle)
        //     console.log("   ",mouseAngle-360, 360-lastAngle,360-lastAngle - zodiac_deg[i])
        // console.log(mouseAngle, zodiac_deg[i], zodiac_deg[(i+1)%12])
        let angle1 = this.zodiac_deg[i],
          angle2 = this.zodiac_deg[(i + 1) % 12];

        if (angle1 > 360 && angle2 > 360) {
          angle1 = angle1 - 360;
          angle2 = angle2 - 360;
        } else if (angle1 > 360) {
          angle1 = angle1 - 360;
        }
        let hover =
          mouseDist >= this.house_diameter / 2 &&
          mouseDist <= this.zodiac_diameter / 2 &&
          mouseAngle >= angle1 &&
          mouseAngle <= angle2;
        // console.log(hover, i)
        if (hover == true) {
          // console.log(hover, i)
          // console.log("click on zodiac ",zodiac[i])
          return [i, this.zodiac[i]];
        }
      }

      return [null, null];
    },
    getClickedHouse(sketch, mouseDist, mouseAngle) {
      console.log("get clicked house ", mouseAngle);
      // console.log(houses_deg)
      mouseAngle = 180 - mouseAngle;
      // mouseAngle = mouseAngle + aries_shift
      for (let i = 0; i < this.houses_deg.length; i++) {
        // console.log("== ", mouseAngle,180-mouseAngle, mouseAngle-180)
        // console.log("   ",mouseAngle, houses_deg[i], houses_deg[(i+1)%12] )

        let angle1 = this.houses_deg[i],
          angle2 = this.houses_deg[(i + 1) % 12];

        if (angle1 >= 360 && angle2 >= 360) {
          angle1 = angle1 - 360;
          angle2 = angle2 - 360;
        } else if (angle1 >= 360) {
          angle1 = angle1 - 360;
        }
        // if(angle1<0){
        //   angle1 = angle1+360
        // }
        // if(angle2<0){
        //   angle2 = angle2+360
        // }
        // console.log("---",mouseAngle, angle1, angle2 )

        let hover =
          this.aspects_circle_diameter / 2 >= 130 &&
          mouseDist <= this.house_diameter / 2 &&
          mouseAngle >= angle1 &&
          mouseAngle <= angle2;
        // console.log(hover, i)
        if (hover == true) {
          // console.log(hover, i+1)
          // console.log("click on house ",(i+1),angles[i])
          return i + 1;
        }
      }

      // console.log("major houses")
      // console.log(major_houses)
      return null;
    },
    getClickedPlanet(sketch, clickedX, clickedY) {
      console.log("in get clicked planet");
      // console.log(painted_planets_positions)
      // console.log(clickedX, clickedY)
      for (let i = 0; i < this.painted_planets_positions.length; i++) {
        // console.log(painted_planets_positions[i])
        let obj = this.painted_planets_positions[i];
        if (
          clickedX >= obj.x - obj.width / 2 &&
          clickedX <= obj.x + obj.width / 2 &&
          clickedY >= obj.y - obj.height / 2 &&
          clickedY <= obj.y + obj.height / 2
        ) {
          // console.log("      ",obj)
          // console.log("      ",obj.planet)

          this.drawAllAspects = false;
          this.resetButton.style("display", "block");
          console.log("================-----------------");
          console.log(obj);
          return obj;
        }
      }
      return null;
    },
    getClickAspect(sketch, mouse_x, mouse_y) {
      console.log("in get clicked aspect");
      this.clickedAspects = [];
      for (let i = 0; i < this.painted_aspects.length; i++) {
        let aspect = this.painted_aspects[i];
        //     console.log("=========================", mouse_x, mouse_y)

        //     console.log(mouse_x, mouse_y,
        //                        aspect.from_x, aspect.from_y,
        //                        aspect.to_x, aspect.to_y)
        //     console.log(painted_aspects[i])
        //
        if (
          this.drawAllAspects == true ||
          (this.drawAllAspects == false &&
            this.clicked_planet_object != null &&
            (aspect.from_planet == this.clicked_planet_object.planet ||
              aspect.to_planet == this.clicked_planet_object.planet))
        ) {
          let is_point_on_line = this.checkIfPointOnLine(
            sketch,
            mouse_x,
            mouse_y,
            aspect.from_x,
            aspect.from_y,
            aspect.to_x,
            aspect.to_y
          );
          if (is_point_on_line) {
            // console.log(this.painted_aspects[i]);
            this.clickedAspects.push(this.painted_aspects[i]);
          }
        }
      }
      console.log("=========>>>>>>>> clicked aspects");
      console.log(this.clickedAspects);
      // for (let i = 0; i < this.clickedAspects.length; i++) {
      //   console.log(this.clickedAspects[i]);
      // }
    },
    getAspectsOfClickedPlanets(sketch, planet) {
      console.log("in get aspects of clicked planets", planet);
      // console.log(painted_aspects)
      this.selectedAspects = [];
      this.painted_aspects.find((aspect) => {
        // console.log( planet, aspect.from_planet, aspect.to_planet )
        if (aspect.from_planet === planet || aspect.to_planet === planet) {
          // console.log(aspect)
          this.selectedAspects.push(aspect);
          //       stroke('#E02ADB')
          //       strokeWeight(2)

          //     line(aspect.from_x, aspect.from_y,
          //           aspect.to_x, aspect.to_y);
          //           console.log(aspect)
        }
      });
      // console.log(selectedAspects)
    },
    getAngleInZodiac(sketch, angle) {
      // console.log("in get angle in zodiac ", angle);
      // console.log(this.zodiac_deg);
      // console.log(major_houses)
      angle = 180 - angle;
      if (angle > 360) {
        angle = angle - 360;
      }
      // console.log("in get angle in zodiac ", angle)
      let returned_angle = 0;
      for (let i = 0; i < this.zodiac_deg.length; i++) {
        let angle1 = this.zodiac_deg[i],
          angle2 = this.zodiac_deg[(i + 1) % this.zodiac_deg.length];
        // console.log("--",angle1, angle2,"-->",angle)
        if (angle1 > 360 && angle2 > 360) {
          angle1 = angle1 - 360;
          angle2 = angle2 - 360;
        } else if (angle1 > 360) {
          angle1 = angle1 - 360;
        }
        // console.log(
        //   returned_angle,
        //   " , " + angle + " , " + angle1 + " , " + angle2
        // );

        // console.log("  ",angle1, angle2)
        if (angle >= angle1 && angle < angle2) {
          // console.log("zzzzzz",i)
          returned_angle = angle - angle1;
          // returned_angle = sketch.round(returned_angle, 5);
          // return i +" , "+round(returned_angle,2);
          // console.log(
          //   sketch.round(returned_angle, 2),
          //   returned_angle + " , " + angle + " , " + angle1 + " , " + angle2
          // );
          return this.convertDecimalToDMS(sketch, returned_angle, false);
        }
        // console.log("---------------------------")
      }

      return returned_angle;
    },
    getZodiacOrPlanetOfAngle(sketch, angle, data, type) {
      // console.log("in get angle in ", type, angle);
      // console.log(data);
      // console.log(major_houses)
      angle = 180 - angle;
      if (angle > 360) {
        angle = angle - 360;
      }
      let returned_index = 0;
      for (let i = 0; i < data.length; i++) {
        let angle1 = data[i],
          angle2 = data[(i + 1) % data.length];
        // console.log("--",angle1, angle2,"-->",angle)
        if (angle1 > 360 && angle2 > 360) {
          angle1 = angle1 - 360;
          angle2 = angle2 - 360;
        } else if (angle1 > 360) {
          angle1 = angle1 - 360;
        }
        // console.log(
        //   returned_index,
        //   " , " + angle + " , " + angle1 + " , " + angle2
        // );

        // console.log("  ",angle1, angle2)
        if (angle >= angle1 && angle < angle2) {
          // console.log("zzzzzz",i)
          returned_index = i;
          // returned_index = sketch.round(returned_index, 5);
          // return i +" , "+round(returned_index,2);
          // console.log(
          //   sketch.round(returned_index, 2),
          //   returned_index + " , " + angle + " , " + angle1 + " , " + angle2
          // );
          return returned_index;
        }
        // console.log("---------------------------")
      }

      return returned_index;
    },
    getAngleAndZodiac(sketch, angle) {
      // console.log("in get angle in zodiac ", angle);
      // console.log(this.zodiac_deg);
      // console.log(major_houses)
      angle = 180 - angle;
      if (angle > 360) {
        angle = angle - 360;
      }
      // console.log("in get angle in zodiac ", angle)
      let returned_angle = 0;
      for (let i = 0; i < this.zodiac_deg.length; i++) {
        let angle1 = this.zodiac_deg[i],
          angle2 = this.zodiac_deg[(i + 1) % this.zodiac_deg.length];
        // console.log("--",angle1, angle2,"-->",angle)
        if (angle1 > 360 && angle2 > 360) {
          angle1 = angle1 - 360;
          angle2 = angle2 - 360;
        } else if (angle1 > 360) {
          angle1 = angle1 - 360;
        }
        // console.log(
        //   returned_angle,
        //   " , " + angle + " , " + angle1 + " , " + angle2
        // );

        // console.log("  ",angle1, angle2)
        if (angle >= angle1 && angle < angle2) {
          // console.log("zzzzzz",i)
          returned_angle = angle - angle1;
          // returned_angle = sketch.round(returned_angle, 5);
          // return i +" , "+round(returned_angle,2);
          // console.log(
          //   sketch.round(returned_angle, 2),
          //   returned_angle + " , " + angle + " , " + angle1 + " , " + angle2
          // );
          return [i, this.convertDecimalToDMS(sketch, returned_angle, true)];
        }
        // console.log("---------------------------")
      }

      return [-1, returned_angle];
    },
    resetAspects() {
      console.log("reset aspects");
      this.drawAllAspects = true;
      this.resetButton.style("display", "none");
      console.log(this.resetButton);
      console.log(this.$refs.vueP5BirthChart);
      // this.$refs.vueP5BirthChart.draw()
      this.draw(this.sketch);
      // this.redraw();
      // this.drawBirthChart(sketch);
    },

    /////////// get clicked item data function
    displayClickedZodiacData(zodiac, zodiac_index) {
      this.clicked_item_items = [];
      for (let i = 0; i < this.painted_planets_positions.length; i++) {
        let planet = this.painted_planets_positions[i];
        // console.log(planet, zodiac_index, planet.zodiac_index)
        if (zodiac_index == planet.zodiac_index) {
          this.clicked_item_items.push({
            title: planet.planet + " in " + zodiac,
            description:
              planet.planet +
              " in " +
              zodiac +
              planet.planet +
              " in " +
              zodiac +
              planet.planet +
              " in " +
              zodiac +
              planet.planet +
              " in " +
              zodiac +
              planet.planet +
              " in " +
              zodiac +
              planet.planet +
              " in " +
              zodiac,
          });
        }
      }
      if (this.clicked_item_items.length != 0) {
        this.clicked_item_title =
          "You have clicked in zodiac " +
          zodiac +
          ". There are " +
          this.clicked_item_items.length +
          " planets in this zodiac";
      } else {
        this.clicked_item_title =
          "You have clicked in zodiac " +
          zodiac +
          ". There are no planets in this zodiac";
      }
    },
    displayClickedHouseData(house_num) {
      this.clicked_item_items = [];
      for (let i = 0; i < this.painted_planets_positions.length; i++) {
        let planet = this.painted_planets_positions[i];
        if (house_num == planet.house_index + 1) {
          this.clicked_item_items.push({
            title: planet.planet + " in house no. " + house_num,
            description:
              planet.planet +
              " in house no. " +
              house_num +
              planet.planet +
              " in house no. " +
              house_num +
              planet.planet +
              " in house no. " +
              house_num,
          });
        }
      }
      if (this.clicked_item_items.length != 0) {
        this.clicked_item_title =
          "You have clicked in house no. " +
          house_num +
          ". There are " +
          this.clicked_item_items.length +
          " planets in this house";
      } else {
        this.clicked_item_title =
          "You have clicked in house no. " +
          house_num +
          ". There are no planets in this house";
      }
    },
    displayClickedPlanetData(planet_object) {
      let planet = planet_object.planet;
      this.clicked_item_title = "You have clicked on " + planet;
      this.clicked_item_items = [
        {
          title: planet + " in house no. " + (planet_object.house_index + 1),
          description:
            planet +
            " in house no. " +
            (planet_object.house_index + 1) +
            planet +
            " in house no. " +
            (planet_object.house_index + 1),
        },
        {
          title:
            planet + " in zodiac " + this.zodiac[planet_object.zodiac_index],
          description:
            planet +
            " in zodiac " +
            this.zodiac[planet_object.zodiac_index] +
            planet +
            " in zodiac " +
            this.zodiac[planet_object.zodiac_index],
        },
      ];
      for (let i = 0; i < this.selectedAspects.length; i++) {
        let aspect = this.selectedAspects[i];
        this.clicked_item_items.push({
          title:
            aspect.from_planet +
            " " +
            aspect.aspect_type +
            " " +
            aspect.to_planet,
          description:
            aspect.from_planet +
            " " +
            aspect.aspect_type +
            " " +
            aspect.to_planet +
            " " +
            aspect.from_planet +
            " " +
            aspect.aspect_type +
            " " +
            aspect.to_planet,
        });
      }
    },
    displayClickedAspects() {
      console.log(this.clickedAspects);
      if (this.clickedAspects.length != 0) {
        this.clicked_item_title = "The current aspects you clicked: ";
        this.clicked_item_items = [];
        for (let i = 0; i < this.clickedAspects.length; i++) {
          let aspect = this.clickedAspects[i];
          this.clicked_item_items.push({
            title:
              aspect.from_planet +
              " " +
              aspect.aspect_type +
              " " +
              aspect.to_planet,
            description:
              aspect.from_planet +
              " " +
              aspect.aspect_type +
              " " +
              aspect.to_planet +
              " " +
              aspect.from_planet +
              " " +
              aspect.aspect_type +
              " " +
              aspect.to_planet,
          });
        }
      } else {
        this.clicked_item_title = "There is no thing in this area";
        this.clicked_item_items = [];
      }
    },
    ///////////////////// help functions

    getDegMinSec(sketch, degminsec) {
      let degminsec_split = sketch.splitTokens(degminsec, ["°", "'", '"']);
      return degminsec_split;
    },
    getDegInDecimal(sketch, deg) {
      //console.log(deg)
      let degree = sketch.int(deg[0]),
        minutes = sketch.int(deg[1]),
        seconds = sketch.int(deg[2]);
      let decimalDegrees = degree + minutes / 60 + seconds / 3600;
      return decimalDegrees;
    },
    convertDecimalToDMS(sketch, deg, is_all) {
      let dms_deg = "";
      let d = sketch.int(deg);
      let m = sketch.int((deg - d) * 60);
      let s = sketch.round((deg - d - m / 60) * 3600, 0);

      if (is_all) {
        dms_deg = d + "° " + m + "' " + s + '"';
      } else {
        dms_deg = d + "°" + m + "'";
      }

      // console.log(
      //   "DMS -- ",
      //   deg + " , " + d + " , " + m + " , " + s + " , " + dms_deg
      // );

      return dms_deg;
    },
    intersection(rect1, rect2) {
      var x1 = rect2.x,
        y1 = rect2.y,
        x2 = x1 + rect2.width,
        y2 = y1 + rect2.height;
      if (rect1.x > x1) {
        x1 = rect1.x;
      }
      if (rect1.y > y1) {
        y1 = rect1.y;
      }
      if (rect1.x + rect1.width < x2) {
        x2 = rect1.x + rect1.width;
      }
      if (rect1.y + rect1.height < y2) {
        y2 = rect1.y + rect1.height;
      }
      return x2 <= x1 || y2 <= y1
        ? false
        : { x: x1, y: y1, width: x2 - x1, height: y2 - y1 };
    },

    checkIfPointOnLine(sketch, pointX, pointY, startX, startY, endX, endY) {
      var tolerance = 8;

      var m = (startY - endY) / (startX - endX);

      var b = startY - m * startX;

      var y = m * pointX + b;
      var delta = sketch.abs(y - pointY);
      if (delta < tolerance) {
        // console.log("delta: " + delta);
        // console.log("The point is on the line");
        return true;
      } else {
        // console.log("delta: " + delta);
        // console.log("The point is not on the line");
        return false;
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/P5/Index.vue